var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6 col-lg-7 col-xl-8" }, [
            _c(
              "h5",
              {
                staticClass:
                  "action-header typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile"
              },
              [_vm._v("\n          " + _vm._s(_vm.cardTitle) + "\n        ")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-md-6 col-lg-5 col-xl-4 hidden-sm-down" },
            [
              _c("div", { staticClass: "action-btn-row" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary float-right mr-1",
                    on: { click: _vm.openCardPreview }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.preview")))]
                )
              ])
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-4 pt-1",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _c("div", { staticClass: "row" }, [
          !_vm.card
            ? _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "card-row" }, [_c("DummyCard")], 1)
              ])
            : _c("div", { staticClass: "col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "card-row" },
                  [
                    _c("Card", { staticClass: "library-detail-card" }, [
                      _c("div", {
                        staticClass: "card-cover-img-thumb",
                        style: _vm.styleBindings
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-block" }, [
                        _c("div", { staticClass: "card-info-section" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.subject")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.getSubjectLabel(_vm.card)) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.grade")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--body-3 typography--color-primary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.getGradeLabel(_vm.card)) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t("card_details.card_meta.chapter")
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _vm.card.chapter_name
                                ? _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-primary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(_vm.card.chapter_name) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-disabled"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      -\n                    "
                                      )
                                    ]
                                  )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t(
                                          "card_details.card_meta.core_concept"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _vm.card.core_concept_id
                                ? _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-primary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.getCoreConceptLabel(
                                              _vm.card.core_concept
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-disabled"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      -\n                    "
                                      )
                                    ]
                                  )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card-keywords-section" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-3" }, [
                              _c(
                                "small",
                                {
                                  staticClass:
                                    "typography--caption typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(
                                        _vm.$t(
                                          "card_details.card_meta.learning_elements"
                                        )
                                      ) +
                                      "\n                    "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-9" }, [
                              _vm.card.core_concept_id
                                ? _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-primary"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.getLearningElements(
                                              _vm.card.core_concept
                                            )
                                          ) +
                                          "\n                    "
                                      )
                                    ]
                                  )
                                : _c(
                                    "small",
                                    {
                                      staticClass:
                                        "typography--body-3 typography--color-disabled"
                                    },
                                    [
                                      _vm._v(
                                        "\n                      -\n                    "
                                      )
                                    ]
                                  )
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-bottom-desc" }, [
                        _c(
                          "small",
                          {
                            staticClass:
                              "typography--caption typography--color-secondary"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("common.card.non_quiz")) +
                                " " +
                                _vm._s(
                                  _vm.$t("common.card.count", {
                                    cnt:
                                      _vm.card.page_count - _vm.card.quiz_count
                                  })
                                ) +
                                " ∙\n                " +
                                _vm._s(_vm.$t("common.card.quiz")) +
                                " " +
                                _vm._s(
                                  _vm.$t("common.card.count", {
                                    cnt: _vm.card.quiz_count
                                  })
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "small",
                          {
                            staticClass:
                              "typography--caption typography--color-secondary"
                          },
                          [
                            _c("strong", [_vm._v(_vm._s(_vm.cardAuthorName))]),
                            _vm._v(" "),
                            _vm.card.assigned_count
                              ? _c("span", [
                                  _vm._v(
                                    "| " +
                                      _vm._s(
                                        _vm.$t("common.card.share_count", {
                                          cnt: _vm.card.assigned_count
                                        })
                                      )
                                  )
                                ])
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.card.publisher_id
                          ? _c(
                              "small",
                              {
                                staticClass:
                                  "typography--caption typography--color-secondary"
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("common.card.updated_at")) +
                                    ": " +
                                    _vm._s(
                                      _vm._f("datetime")(_vm.card.updated_at)
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ])
                  ],
                  1
                )
              ]),
          _vm._v(" "),
          !_vm.pagesReady
            ? _c("div", { staticClass: "col-md-8" }, [
                _c(
                  "div",
                  { staticClass: "card-row" },
                  [_c("DummyPageSummary")],
                  1
                )
              ])
            : _c(
                "div",
                { staticClass: "col-md-8" },
                _vm._l(_vm.card.pages, function(page, index) {
                  return _c(
                    "div",
                    { key: page.id, staticClass: "card-row" },
                    [
                      _c("PageSummary", { attrs: { page: page, index: index } })
                    ],
                    1
                  )
                }),
                0
              )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "b-modal",
          {
            staticClass: "basic-modal no-header-modal hide-cancel-btn",
            attrs: {
              id: "no-class-to-assign-alert",
              "hide-header": true,
              "ok-title": _vm.$t("common.confirm")
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("common.modal.no_class_to_assign_alert.message")
                )
              }
            })
          ]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "hidden-md-up",
        attrs: { slot: "floating-action-menu" },
        slot: "floating-action-menu"
      },
      [
        _c(
          "FloatingDropup",
          [
            _c("b-dropdown-item", { on: { click: _vm.openCardPreview } }, [
              _vm._v(_vm._s(_vm.$t("common.preview")))
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74c30b86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74c30b86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/library/views/CardDetails.vue
// module id = slOa
// module chunks = 1